/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:max-line-length

import { BehaviorSubject, Observable } from 'rxjs';
import { ContainerState } from './container-state';
import { setEntityFields } from './immutable';
import { MutablePageState } from './mutable-page-state';

export interface ContainerSelectionState<S> {
  readonly selection: S;
  readonly selectionChanges: Observable<S>;

  setSelection(selection: S): void;

  mergeSelection(selection: Partial<S>): void;
}

export function mixinSelectionState<C extends Constructor<ContainerState<T>>, T, S>(base: C,
                                                                                    initSelection: S): Constructor<ContainerSelectionState<S>> & C {
  return class extends base implements ContainerSelectionState<S> {
    selection$$ = new BehaviorSubject<S>(initSelection);

    get selection(): S {
      return this.selection$$.value;
    }

    get selectionChanges(): Observable<S> {
      return this.selection$$.asObservable();
    }

    setSelection(selection: S): void {
      this.selection$$.next(selection);
    }

    mergeSelection(selection: Partial<S>): void {
      this.selection$$.next(setEntityFields(this.selection, selection));
    }
  };
}

export function MutablePageStateWithSelection<T, S>(initSelection: S): Constructor<MutablePageState<T> & ContainerSelectionState<S>> {
  return mixinSelectionState(MutablePageState, initSelection);
}
